import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';
import {
  deleteAdminV1StoresStoreIdBlogCategoriesId,
  deleteAdminV1StoresStoreIdBlogPostsId,
  getAdminV1StoresStoreIdBlogCategories,
  getAdminV1StoresStoreIdBlogPosts,
  getAdminV1StoresStoreIdBlogPostsId,
  patchAdminV1StoresStoreIdBlogCategoriesId,
  patchAdminV1StoresStoreIdBlogPostsId,
  postAdminV1StoresStoreIdBlogCategories,
  postAdminV1StoresStoreIdBlogPosts,
  type BlogCategory,
  type BlogPost,
  type GetAdminV1StoresStoreIdBlogPosts200,
  type PatchAdminV1StoresStoreIdBlogCategoriesIdBody,
  type PatchAdminV1StoresStoreIdBlogPostsIdBody,
  type PostAdminV1StoresStoreIdBlogCategoriesBody,
  type PostAdminV1StoresStoreIdBlogPostsBody,
} from '@nucleus-commerce/api-client/admin';

/**
 * Post list params as `listParams` builds them from the route's search: `q`, `sort`, the flat
 * filter params (`status=draft`, `categoryId=a,b`, `publishedAt_gte=2026-09-01`), `cursor`, `limit`.
 */
export type BlogPostListParams = ListParams;

export const blogApi = {
  listPosts: (
    storeId: string,
    params: BlogPostListParams,
  ): Promise<GetAdminV1StoresStoreIdBlogPosts200> =>
    getAdminV1StoresStoreIdBlogPosts({ storeId }, params),
  getPost: (storeId: string, id: string): Promise<BlogPost> =>
    getAdminV1StoresStoreIdBlogPostsId({ storeId, id }),
  createPost: (storeId: string, body: PostAdminV1StoresStoreIdBlogPostsBody): Promise<BlogPost> =>
    postAdminV1StoresStoreIdBlogPosts({ storeId }, body),
  updatePost: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdBlogPostsIdBody,
  ): Promise<BlogPost> => patchAdminV1StoresStoreIdBlogPostsId({ storeId, id }, body),
  removePost: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdBlogPostsId({ storeId, id }),

  /** Bounded (100 per store), ordered by position. */
  listCategories: (storeId: string): Promise<BlogCategory[]> =>
    getAdminV1StoresStoreIdBlogCategories({ storeId }).then((r) => r.items),
  createCategory: (
    storeId: string,
    body: PostAdminV1StoresStoreIdBlogCategoriesBody,
  ): Promise<BlogCategory> => postAdminV1StoresStoreIdBlogCategories({ storeId }, body),
  updateCategory: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdBlogCategoriesIdBody,
  ): Promise<BlogCategory> => patchAdminV1StoresStoreIdBlogCategoriesId({ storeId, id }, body),
  removeCategory: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdBlogCategoriesId({ storeId, id }),
};
